import React, {FC, useEffect} from 'react';
import {IProjectListProps} from '@common/types';
import TimeLineItem from '@components/common/TimeLineItem';
import {useFilterBySelectTag} from '@common/hooks/useFilterBySelectTag';
import {useSelectTag} from '@common/hooks/useSelectTag';
import {useRouter} from 'next/router';


const ProjectTimeLine: FC<IProjectListProps> = ({projects}) => {
  const router = useRouter();
  const {selectedTagSlug, setSelectedTagSlug} = useSelectTag('projects');

  useEffect(() => {
    const slug = router.asPath.split('#')[1] ?? null;
    setSelectedTagSlug(slug);
  }, []);

  const {wasTagChanged, items} = useFilterBySelectTag({
    selectedTagSlug: selectedTagSlug ?? null,
    initialData: projects || [],
    manyTags: true
  });

  return (
    <ul className={`project__text-list ${wasTagChanged ? 'is-active' : ''}`}>
      {items?.map((item, index) => (
        <TimeLineItem item={item} key={`timeline_${item.slug}_${index}`}/>
      ))}
    </ul>
  )
}

export default ProjectTimeLine
